import React, { Component } from "react";

import Script from "react-load-script";

import { Box } from "src/components";

class Wistia extends Component {
  state = {
    dataLoaded: false,
  };
  handleDataLoad = () => {
    this.setState({ dataLoaded: true });
  };

  render() {
    const { options } = this.props;

    const videoId = options.videoId;

    return (
      <Box>
        <div
          className="wistia_responsive_padding"
          style={{ padding: "56.25% 0 0 0", position: "relative" }}
        >
          <div
            className="wistia_responsive_wrapper"
            style={{
              height: "100%",
              left: 0,
              position: "absolute",
              top: 0,
              width: "100%",
            }}
          >
            <div
              className={`wistia_embed wistia_async_${videoId} seo=false videoFoam=true`}
              style={{ height: "100%", width: "100%" }}
            />
          </div>
        </div>
        <Script url={`//fast.wistia.com/embed/medias/${videoId}.jsonp`} />
        <Script url="//fast.wistia.com/assets/external/E-v1.js" />
      </Box>
    );
  }
}

export default Wistia;



// WEBPACK FOOTER //
// ./src/components/Content/Module/Wistia.js